import React, {useEffect, useRef} from "react";
import {Button, Label} from "reactstrap";
import {IExoReplacerBody} from "../../../../store/exo/types";
import ExoReplacerRow from "./ExoReplacerRow";

interface ExoReplacerListProps {
    label?: string;
    value: IExoReplacerBody[];
    isAddingReplacement?: boolean;
    disabled?: boolean;
    onChange: (value: IExoReplacerBody[]) => void;
}

const ExoReplacerList: React.FC<ExoReplacerListProps> = ({
                                                             value,
                                                             disabled = false,
                                                             isAddingReplacement = false,
                                                             onChange,
                                                             label = "Replacements"
                                                         }) => {
    const focusRef = useRef<HTMLInputElement>(null);
    const shouldFocusLast = useRef(false);

    const addReplacement = () => {
        shouldFocusLast.current = true;
        onChange([...value, {from: "", to: ""}])
    };

    const updateReplacement = (i: number, replacement: IExoReplacerBody) =>
        onChange(value.map((f, idx) => (idx === i ? replacement : f)));

    const removeReplacement = (i: number) =>
        onChange(value.filter((_, idx) => idx !== i));

    const canAddReplacement = value.length === 0 || value.every(f => !!f.from && !!f.to);

    useEffect(() => {
        if (shouldFocusLast.current) {
            focusRef.current?.focus();
            shouldFocusLast.current = false;
        }
    }, [value.length]);

    useEffect(() => {
        if (isAddingReplacement) addReplacement();
    }, [isAddingReplacement]);

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <Label className="mb-0">{label}</Label>
                <Button color="light" size="sm" type="button" onClick={addReplacement} disabled={!canAddReplacement || disabled}>
                    <i className="mdi mdi-plus me-1"></i>
                    Add replacement
                </Button>
            </div>

            {value.length === 0 && <div className="text-muted small">No replacements added</div>}

            {value.map((replacement, i) => (
                <ExoReplacerRow
                    key={i}
                    disabled={disabled}
                    replacement={replacement}
                    focusRef={value.length - 1 === i ? focusRef : undefined}
                    onChange={f => updateReplacement(i, f)}
                    onRemove={() => removeReplacement(i)}
                />
            ))}
        </div>
    );
};

export default ExoReplacerList;